import React from "react";
import CustomFooter from "../CustomFooter/CustomFooter";
import CustomHeader from "../CustomHeader/CustomHeader";
import { LayoutContainer } from "./CustomLayoutStyles";

const CustomLayout = ({
  children,
  isLoginScreen,
  showMenuNav,
  footerPosition,
  footerWidth,
  marginContainer,
  testid,
}) => {
  return (
    <LayoutContainer margin={marginContainer} testid={testid}>
      <CustomHeader isLoginScreen={isLoginScreen} showMenuNav={showMenuNav} />

      {children}

      <CustomFooter
        isLoginScreen={isLoginScreen}
        footerPosition={footerPosition}
        footerWidth={footerWidth}
      />
    </LayoutContainer>
  );
};

export default CustomLayout;